import Vue from 'vue'
import { RoutePath as routes } from '@/router'
import { RawLocation } from 'vue-router/types/router'
import { Entry } from 'contentful'
import { CfAnslContactForm } from '@/types/ansl-space/types/cf-ansl-contact-form'

import {
  accessorFactory,
  Namespace
} from '@/store'
const {
  fetchContent,
  getContent
} = accessorFactory<Entry<CfAnslContactForm>>(Namespace.ContactFormContent)
import { initAuthStore } from '@/store/modules/authentication-v6.store'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const beforeEnterContactForm = async (vm: Vue, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) => {
  await initAuthStore(vm.$store)
  await fetchContent(vm.$store)
  const pageVisibility = getContent(vm.$store)

  if (pageVisibility && pageVisibility.fields.hideForm) {
    next({ path: routes.LandingPage })
    return
  }

  next()
}

export default beforeEnterContactForm
